import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=010f7143&"
import script from "./Language.vue?vue&type=script&lang=js&"
export * from "./Language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('010f7143')) {
      api.createRecord('010f7143', component.options)
    } else {
      api.reload('010f7143', component.options)
    }
    module.hot.accept("./Language.vue?vue&type=template&id=010f7143&", function () {
      api.rerender('010f7143', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Language.vue"
export default component.exports